import { EventBusKey } from '@vueuse/core'

interface useEventDistributorReturn {
  send: Function
  receive: Function
}
export function useEventDistributor(
  busKey: EventBusKey<string>,
): useEventDistributorReturn {
  const { emit, on, reset } = useEventBus<Recordable>(busKey)

  /**
   * @description Publish data
   * @param data
   */
  function send(data: Recordable) {
    emit(data)
  }

  /**
   * @description Subscribe data
   * @param onReceivedCallback {Function}
   */
  function receive(onReceivedCallback: Function) {
    on((receivedData) => {
      onReceivedCallback(receivedData)
    })
  }

  onUnmounted(() => reset())

  return { send, receive }
}
